//아이디 (영어,숫자 포함 6~12자)
const id = (data) => {
    const regex = /^(?=.*[a-zA-Z])[a-zA-Z0-9]{6,12}$/;
    return regex.test(data);
}

//비밀번호(영문+숫자+특수문자 포함 8~15자)
const pswd = (data) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$!%*?&^~])[A-Za-z\d@#$!%*?&^~]{8,15}$/;
    return regex.test(data);
}

// 이메일
const email = (data) => {
    const regex = /^[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/;
    return regex.test(data);
}

const mbpnTlno = (data) => {
    const regex = /^01[016789]-?\d{3,4}-?\d{4}$/;
    return regex.test(data);
}

const iirno = (data) => {
    let is = true;
    // 숫자만 포함되는지 확인하는 정규식
    const numberRegex = /^[0-9]+$/;

    data = data.replace(/-/g, '');
    // 주민등록번호는 "-"를 포함하여 13자리여야 합니다.
    if (!numberRegex.test(data) || data.length !== 13) {
        is = false;
    }

    // 주민등록번호의 앞 6자리를 연월일로 나타내는지 확인
    const ymd = data.substring(0, 6);
    const yy = Number(ymd.substring(0, 2));
    const mm = Number(ymd.substring(2, 4));
    const dd = Number(ymd.substring(4, 6));

    if ((yy < 0 || yy > 99)
            || (mm < 1 || mm > 12)
                || (dd < 1 || dd > 31)) {
        is = false;
    }

    //주민등록번호 뒷자리 첫번째 자리수만 체크
    const key = Number(data.substring(6, 7));
    if (key > 8 || key < 1) {
        is = false;
    }

    // 주민등록번호의 뒷자리 유효성 검사
    /*const lastDigit = parseInt(data[12], 10);
    const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
    let sum = 0;
    for (let i = 0; i < 12; i++) {
        sum += parseInt(data[i], 10) * weights[i];
    }
    const remainder = sum % 11;
    const result = 11 - remainder;
    const checkDigit = result === 10 ? 0 : result;
    if (checkDigit !== lastDigit) {
        is = false;
    }*/

    // 모든 조건을 통과한 경우 유효한 주민등록번호입니다.
    return is;
}

const isDate = (dateStr) => {
    // YYYYMMDD 또는 YYYYMM 형식만 허용

    //년월인 경우는 01을 더해서 날짜 확인
    if (dateStr.length == 6) dateStr += '01';
    const datePattern = RegExp(/^\d{4}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/);

    return datePattern.test(dateStr);
}

//기간 체크
const dateRange = (start, end) => {
    let is = true;
    if (start > end) is = false;
    return is;
}

// 파일 확장자
const fileExtsn = (extsn, acceptsTxt) => {
    let is = true;

    const accepts = acceptsTxt.split(',');

    const info = accepts.find(accept => accept.toLowerCase() == extsn.toLowerCase());
    if (!info) is = false;

    return is;
}

// 길이 체크
const length = (txt, txtLength) => {
    let is = true;

    if (!txt) is = false;
    if (txt.length > txtLength) is = false;

    return is;
}

const isKorean = (data) => {
    const regex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    return regex.test(data);
}

const useValid = () => {
    return {
        id,
        pswd,
        email,
        mbpnTlno,
        iirno,
        isDate,
        dateRange,
        fileExtsn,
        length,
        isKorean
    };
};

export { useValid };
